import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome!");
      const next = params.get("next");
      nav(next && next.startsWith("/") ? next : "/");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
      <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_25%_25%,#00A3E0_0,transparent_50%),radial-gradient(circle_at_75%_75%,#EC008C_0,transparent_50%)]" />
      <Card className="relative w-full max-w-md p-8 bg-slate-900/90 backdrop-blur border-slate-800 text-slate-100" data-testid="login-card">
        <div className="mb-6">
          <img src="/rozfa-logo-white.png" alt="Rozfa Print Ops" className="h-12 w-auto" data-testid="login-logo" />
          <p className="text-xs text-slate-400 font-mono mt-2">Internal Operations Console</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-slate-300">Email</Label>
            <Input
              type="email" required autoFocus
              value={email} onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="bg-slate-800 border-slate-700 text-slate-100"
            />
          </div>
          <div>
            <Label className="text-slate-300">Password</Label>
            <Input
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="bg-slate-800 border-slate-700 text-slate-100"
            />
          </div>
          <Button
            type="submit" disabled={loading}
            className="w-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold"
            data-testid="login-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
          </Button>
        </form>
        <div className="mt-6 pt-6 border-t border-slate-800 text-xs text-slate-500 font-mono">
          Staff-only access • Authorised personnel
          <div className="mt-2">Rozfa Agent? <a href="/agent/login" className="text-amber-400 hover:underline" data-testid="to-agent-portal">Go to Agent Portal →</a></div>
        </div>
      </Card>
    </div>
  );
}
